import { API_BASE } from '../config';

export const trackFeatureUsage = async ({
  feature,
  documentId,
  token,
  masterKey,
}: {
  feature: 'document_read_aloud';
  documentId?: string | null;
  token?: string | null;
  masterKey?: string | null;
}): Promise<void> => {
  if (!token && !masterKey) {
    return;
  }
  if (documentId != null && documentId === 'new') {
    return;
  }

  try {
    const url = masterKey
      ? `${API_BASE}/api/feature-tracking?masterKey=${encodeURIComponent(masterKey)}`
      : `${API_BASE}/api/feature-tracking`;
    await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token && !masterKey ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({
        documentId: documentId ?? null,
        feature,
      }),
    });
  } catch (error) {
    console.error('Error tracking feature usage:', error);
  }
};
